import React, { useEffect, useState } from 'react';
import axios from '../api';
import { Container, Typography, Paper, Box, LinearProgress, Button } from '@mui/material';
import styled from 'styled-components';
import './Home.css';

function formatReal(value) {
  if (value === '' || value === undefined) return '';
  let num = value;
  if (typeof num === 'string') {
    num = num.replace(/\D/g, '');
    if (num === '') return '';
    num = parseFloat(num);
  }
  return (num / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

const Table = styled.table`
  width: 100%;
  max-width: 500px;
  margin: 1rem auto;
  border-collapse: collapse;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(109, 36, 21, 0.1);
`;

const Td = styled.td`
  padding: 0.75rem;
  border-bottom: 1px solid #eee;
`;

const Home = ({ setPage, isAdmin = true }) => {
  const orcamentoTotal = 20000;
  const [loading, setLoading] = useState(true);
  const weddingDate = new Date('2026-07-18T00:00:00');
  const [countdown, setCountdown] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0, isFinished: false });
  const [bgIndex, setBgIndex] = useState(0);
  const [convidadosResumo, setConvidadosResumo] = useState({
    total: 0,
    confirmados: 0,
    presentes: 0,
    por_noivo: {
      Graziele: { total: 0, confirmados: 0 },
      Fernando: { total: 0, confirmados: 0 },
    },
  });
  const bgImages = [
    '/media/20250531_152259.jpg',
    '/media/20250419_202531.jpg',
    '/media/20250302_093752.jpg',
    '/media/20250222_202834.jpg',
    '/media/Imagem do WhatsApp de 2025-07-27 à(s) 18.03.19_6a05dd4e.jpg',
    '/media/Imagem do WhatsApp de 2025-06-01 à(s) 16.48.29_d3833c7e.jpg',
    '/media/Imagem do WhatsApp de 2025-06-01 à(s) 16.48.22_79dd52eb.jpg',
  ];

  const [totais, setTotais] = useState({
    valor_total: 0,
    valor_parcelas: 0,
    valor_parcelas_pagas: 0,
    valor_parcelas_nao_pagas: 0,
    valor_pago_fernando: 0
  });

  useEffect(() => {
    const fetchHomeData = async () => {
      try {
        const [convidadosRes, orcamentoRes] = await Promise.all([
          axios.get('/api/convidados/resumo'),
          axios.get('/api/despesas/resumo'),
        ]);
        setConvidadosResumo(convidadosRes.data);
        setTotais(orcamentoRes.data);
      } finally {
        setLoading(false);
      }
    };

    const refreshConvidados = async () => {
      try {
        const res = await axios.get('/api/convidados/resumo');
        setConvidadosResumo(res.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchHomeData();
    const interval = window.setInterval(() => {
      refreshConvidados();
    }, 5000);
    return () => window.clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!weddingDate) return;
    const interval = setInterval(() => {
      const fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Sao_Paulo',
        hour12: false,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
      });
      const p = fmt.formatToParts(new Date()).reduce((acc, x) => (acc[x.type] = x.value, acc), {});
      const now = new Date(`${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}:${p.second}`);
      const diff = weddingDate - now;
      if (diff > 0) {
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);
        setCountdown({ days, hours, minutes, seconds, isFinished: false });
      } else {
        const days = Math.floor((now - weddingDate) / (1000 * 60 * 60 * 24));
        setCountdown({ days, hours: 0, minutes: 0, seconds: 0, isFinished: true });
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [weddingDate]);

  useEffect(() => {
    const interval = setInterval(() => {
      setBgIndex(i => (i + 1) % bgImages.length);
    }, 20000);
    return () => clearInterval(interval);
  }, []);

  if (loading) return <LinearProgress sx={{ mt: 4 }} />;

  const bgStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: -1,
    background: `url('${bgImages[bgIndex]}') center/cover no-repeat fixed`,
    opacity: 0.18,
    transition: 'background-image 2s',
  };

  const convidadosPorNoivo = convidadosResumo.por_noivo || {
    Graziele: { total: 0, confirmados: 0 },
    Fernando: { total: 0, confirmados: 0 },
  };

  return (
    <>
      <div style={bgStyle}></div>
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom sx={{ fontFamily: 'Great Vibes, Parisienne, cursive', fontSize: { xs: 32, md: 48 }, textAlign: 'center' }}>
          Organização do Casamento Graziele e Fernando
        </Typography>
        {weddingDate && (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 3 }}>
            <Paper
              sx={{
                p: 2,
                bgcolor: countdown.isFinished ? 'rgba(255, 235, 238, 0.95)' : 'rgba(255,255,255,0.85)',
                borderRadius: 3,
                boxShadow: countdown.isFinished ? 6 : 3,
                border: countdown.isFinished ? '2px solid #d32f2f' : 'none',
                animation: countdown.isFinished ? 'pulse 1.2s infinite' : 'none',
                '@keyframes pulse': {
                  '0%': { transform: 'scale(1)' },
                  '50%': { transform: 'scale(1.02)' },
                  '100%': { transform: 'scale(1)' },
                },
              }}
            >
              <Typography variant="h6" align="center" sx={{ fontFamily: 'Parisienne, Great Vibes, cursive', fontSize: 28, mb: 1, color: countdown.isFinished ? '#b71c1c' : 'inherit' }}>
                {countdown.isFinished ? 'E chegou o grande dia!' : 'Contagem Regressiva para o Grande Dia'}
              </Typography>
              {countdown.isFinished ? (
                <Typography align="center" sx={{ fontWeight: 700, fontSize: 22, color: '#b71c1c' }}>
                  Que emoção! {countdown.days} day{countdown.days === 1 ? '' : 's'} Dias de casados, desde 18/07/2026 💕
                </Typography>
              ) : (
                <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', fontSize: 22 }}>
                  <span><b>{countdown.days}</b> dias</span>
                  <span><b>{countdown.hours}</b>h</span>
                  <span><b>{countdown.minutes}</b>m</span>
                  <span><b>{countdown.seconds}</b>s</span>
                </Box>
              )}
            </Paper>
          </Box>
        )}
        <Paper
          sx={{ p: 3, mb: 3, cursor: 'pointer', transition: 'transform 0.2s ease, box-shadow 0.2s ease', '&:hover': { transform: 'translateY(-2px)', boxShadow: 4 } }}
          onClick={() => setPage('convidados')}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 1 }}>
            <Typography variant="h6">Convidados</Typography>
            <Button size="small" variant="outlined" onClick={(e) => { e.stopPropagation(); setPage('convidados'); }}>Ver lista</Button>
          </Box>
          <Typography>Graziele: {convidadosPorNoivo.Graziele.confirmados} de {convidadosPorNoivo.Graziele.total}</Typography>
          <Typography>Fernando: {convidadosPorNoivo.Fernando.confirmados} de {convidadosPorNoivo.Fernando.total}</Typography>
          <Typography>Confirmados: {convidadosResumo.confirmados} de {convidadosResumo.total}</Typography>
          <Typography>Presentes: {convidadosResumo.presentes} de {convidadosResumo.total}</Typography>
        </Paper>
        {isAdmin && (
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6">Orçamento</Typography>
            <Table>
              <tbody>
                <tr>
                  <Td>Valor Total</Td>
                  <Td>{formatReal(totais.valor_total)}</Td>
                </tr>
                <tr>
                  <Td>Valor Parcelas</Td>
                  <Td>{formatReal(totais.valor_parcelas)}</Td>
                </tr>
                <tr>
                  <Td>Parcelas Pagas</Td>
                  <Td>{formatReal(totais.valor_parcelas_pagas)}</Td>
                </tr>
                <tr>
                  <Td>Valor Pago ao Fernando</Td>
                  <Td>{formatReal(totais.valor_pago_fernando)}</Td>
                </tr>
                <tr>
                  <Td>Parcelas Não Pagas</Td>
                  <Td>{formatReal(Math.max(0, totais.valor_parcelas_nao_pagas - totais.valor_pago_fernando))}</Td>
                </tr>
              </tbody>
            </Table>
            <LinearProgress variant="determinate" value={Math.min(100, (totais.valor_total / orcamentoTotal) * 100)} sx={{ height: 10, borderRadius: 5 }} />
          </Paper>
        )}
      </Container>
    </>
  );
};


export default Home;